import { popupComponent } from './popup.component';

export const POPUP_DECLARATIONS: any[] = [popupComponent];